import React from 'react'
import LineTagAltIcon from 'LuxKit/Icons/line/LineTagAltIcon'
import LineGlassMartiniAltIcon from 'LuxKit/Icons/line/LineGlassMartiniAltIcon'
import LineGlobeAltIcon from 'LuxKit/Icons/line/LineGlobeAltIcon'
import LineClockDollarIcon from 'LuxKit/Icons/line/LineClockDollarIcon'
import LinePhoneIcon from 'LuxKit/Icons/line/LinePhoneIcon'
import LineParcelIcon from 'LuxKit/Icons/line/LineParcelIcon'
import LineUserPlusIcon from 'LuxKit/Icons/line/LineUserPlusIcon'
import LineUsdCircleIcon from 'LuxKit/Icons/line/LineUsdCircleIcon'

export const WHY_BOOK_WITH_US_CONTENT =
    [
      {
        Icon: <LineTagAltIcon size="L" />,
        heading: 'Save up to 70% off',
        body: 'We negotiate directly with our travel partners to secure exclusive offers you won’t find elsewhere.',
        link: {
          text: 'Browse offers',
          to: '/',
        },
      },
      {
        Icon: <LineGlassMartiniAltIcon size="L" />,
        heading: 'Bonus VIP inclusions',
        body: 'Handpicked inclusions and exclusive extras will make your trip even more memorable.',
        link: undefined,
      },
      {
        Icon: <LineGlobeAltIcon size="L" />,
        heading: 'One-stop destination',
        body: 'Discover 1,000s of flights, hotels, packages, tours, cruise, experiences, car hire & more.',
        link: undefined,
      },
      {
        Icon: <LineClockDollarIcon size="L" />,
        heading: 'Flexible bookings',
        body: 'Travel with peace of mind with our flexible cancellation policies.',
      },
      {
        Icon: <LinePhoneIcon size="L" />,
        heading: '24/7 customer service',
        body: 'Regardless of your time zone, we offer round-the-clock service.',
      },
      {
        Icon: <LineParcelIcon size="L" />,
        heading: 'Local travel guides and inspiration',
        body: 'Be inspired by expert recommendations and local travel tips.',
        link: {
          text: 'Get inspired',
          href: 'https://luxuryescapes.com/inspiration',
        },
      },
      {
        Icon: <LineUserPlusIcon size="L" />,
        heading: 'Refer a friend',
        body: 'Refer a friend and you’ll both receive credit towards your next escape.',
        link: {
          text: 'Learn more',
          to: '/refer',
        },
      },
      {
        Icon: <LineUsdCircleIcon size="L" />,
        heading: 'Best price guarantee',
        body: 'In the unlikely event that you find a better price for the same offer, we promise to match it.',
        link: {
          text: 'Learn more',
          to: '/best-price-guarantee',
        },
      },
    ]
